var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixRestaurantsOrdersettingsV3OrderSettings from '@wix/ambassador-restaurants-ordersettings-v3-order-settings/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var ApproximateAddresses;
(function (ApproximateAddresses) {
    ApproximateAddresses["EMPTY"] = "EMPTY";
    ApproximateAddresses["BLOCK"] = "BLOCK";
    ApproximateAddresses["ALLOW"] = "ALLOW";
})(ApproximateAddresses || (ApproximateAddresses = {}));
export var Type;
(function (Type) {
    /** Add a page to your site and put your policy document there. You can link to it from here. */
    Type["URL"] = "URL";
    /** The policy will be displayed as plain text in a popup. */
    Type["TEXT"] = "TEXT";
})(Type || (Type = {}));
export var TipsType;
(function (TipsType) {
    /** Tip with exact amount ($) */
    TipsType["AMOUNT"] = "AMOUNT";
    /** Tip in percentage */
    TipsType["PERCENTAGE"] = "PERCENTAGE";
})(TipsType || (TipsType = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MON"] = "MON";
    DayOfWeek["TUE"] = "TUE";
    DayOfWeek["WED"] = "WED";
    DayOfWeek["THU"] = "THU";
    DayOfWeek["FRI"] = "FRI";
    DayOfWeek["SAT"] = "SAT";
    DayOfWeek["SUN"] = "SUN";
})(DayOfWeek || (DayOfWeek = {}));
export var ChargeRoundingStrategy;
(function (ChargeRoundingStrategy) {
    ChargeRoundingStrategy["UNDEFINED"] = "UNDEFINED";
    /** https://en.wikipedia.org/wiki/Rounding#Round_half_away_from_zero */
    ChargeRoundingStrategy["HALF_AWAY_FROM_ZERO"] = "HALF_AWAY_FROM_ZERO";
    /** https://en.wikipedia.org/wiki/Rounding#Round_half_to_even */
    ChargeRoundingStrategy["HALF_EVEN"] = "HALF_EVEN";
})(ChargeRoundingStrategy || (ChargeRoundingStrategy = {}));
const _getOrderSettingsRequest = {};
const _getOrderSettingsResponse = {};
const _listOrderSettingsRequest = {};
const _listOrderSettingsResponse = {};
const _updateOrderSettingsRequest = {};
const _updateOrderSettingsResponse = {};
/**
 * Get a OrderSettings by id
 * @param orderSettingsId - Id of the OrderSettings to retrieve
 * @internal
 * @documentationMaturity preview
 * @requiredField orderSettingsId
 * @returns The retrieved OrderSettings
 */
export function getOrderSettings(orderSettingsId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { orderSettingsId: '$[0]' };
        const responseTransformation = '$.orderSettings';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getOrderSettingsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getOrderSettingsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['orderSettings']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([orderSettingsId]);
        const reqOpts = ambassadorWixRestaurantsOrdersettingsV3OrderSettings.getOrderSettings(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'orderSettingsId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Update a OrderSettings, supports partial update
 * @param _id - Order Settings id
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField orderSettings
 * @requiredField orderSettings.revision
 * @adminMethod
 * @returns The updated OrderSettings
 */
export function updateOrderSettings(_id, orderSettings, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            orderSettings: { '*': '$[1]', id: '$[0]' },
            mask: '$[2].mask',
        };
        const responseTransformation = '$.orderSettings';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateOrderSettingsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['orderSettings']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateOrderSettingsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['orderSettings']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, orderSettings, options]);
        const reqOpts = ambassadorWixRestaurantsOrdersettingsV3OrderSettings.updateOrderSettings(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'orderSettings',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * List Order settings
 * @internal
 * @documentationMaturity preview
 */
export function listOrderSettings(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            restaurantLocationIds: '$[0].restaurantLocationIds',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listOrderSettingsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listOrderSettingsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#orderSettings']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixRestaurantsOrdersettingsV3OrderSettings.listOrderSettings(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=restaurants-ordersettings-v3-order-settings.universal.js.map